import React, {useContext, useState} from 'react';
import {OrderViewContext} from "./OrderViewContext";
import {useNavigate} from "react-router-dom";
import {toast} from "react-toastify";
import {exportXLSXFile} from "../../utils/exportCSVFile";
import DynaDatePicker from "../A13/DynaView/DynaDatePicker";
import _axios from "../../httpService";
import {prefixUrl} from "../../utils/utilsData";

function TableButtons(props) {

  const helper = useContext(OrderViewContext);
  const data = helper.data
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isExporting, setIsExporting] = useState(false);

  const navigateTo = useNavigate()
  console.log(data)

  const compareJalaliDates = (first, second) => {
    const firstParts = first.split("/").map(Number);
    const secondParts = second.split("/").map(Number);
    for (let index = 0; index < 3; index += 1) {
      if (firstParts[index] !== secondParts[index]) {
        return firstParts[index] - secondParts[index];
      }
    }
    return 0;
  };

  const validDateRange = startDate && endDate && compareJalaliDates(startDate, endDate) <= 0;

  const handleExport = async () => {
    if (!validDateRange || isExporting) return;

    setIsExporting(true);
    try {
      const filter = {
        startDate,
        endDate,
        paymentStatus: data.filter?.paymentStatus || "all",
      };
      const response = await _axios.get(
        `${prefixUrl()}/cartTable/?request=tableData&filter=${encodeURIComponent(JSON.stringify(filter))}`,
      );
      const report = response?.data;
      if (!report?.status || !Array.isArray(report.data) || report.data.length === 0) {
        toast.error(report?.message || "برای بازه انتخاب‌شده سفارشی وجود ندارد");
        return;
      }

      const headers = {};
      report.columns?.forEach((column) => {
        if (column.field && column.title) headers[column.field] = column.title;
      });

      const fileRange = `${startDate}_${endDate}`.replace(/\//g, "-");
      exportXLSXFile(report.data, `OrderList_${fileRange}`, headers);
    } catch (error) {
      toast.error("خطا در دریافت اطلاعات خروجی اکسل");
    } finally {
      setIsExporting(false);
    }
  };

  return (<div>

    <div className={"d-flex flex-wrap align-items-end"} style={{gap: 12}}>

      <button
        className={"theme1__btn theme1__btn__main"}
        onClick={() => {
          navigateTo('/OrdersSadan')
        }}
      >
        افزودن سفارش
      </button>
      <div style={{width: 190}}>
        <DynaDatePicker
          label="از تاریخ گزارش اکسل"
          name="exportStartDate"
          className="solid-dyna-input"
          value={startDate}
          maxDate={endDate || undefined}
          setDataFromComponent={(value) => setStartDate(value.exportStartDate)}
        />
      </div>
      <div style={{width: 190}}>
        <DynaDatePicker
          label="تا تاریخ گزارش اکسل"
          name="exportEndDate"
          className="solid-dyna-input"
          value={endDate}
          setDataFromComponent={(value) => setEndDate(value.exportEndDate)}
        />
      </div>
      <button
        className={"theme1__btn mx-2"}
        onClick={handleExport}
        disabled={!validDateRange || isExporting}
      >
        {isExporting ? "در حال آماده‌سازی..." : "خروجی اکسل"}
      </button>
      {/*<button*/}
      {/*  className={"theme1__btn"}*/}
      {/*  onClick={() => {*/}


      {/*    if (data?.selectedRowId) {*/}
      {/*      navigateTo('/OrdersSadan',{state: {id: data?.selectedRowId}})*/}
      {/*    } else {*/}
      {/*    toast('برای ویرایش باید یک سطر را انتخاب کنید.')*/}

      {/*    }*/}
      {/*  }}*/}
      {/*>*/}
      {/*  ویرایش سفارش*/}
      {/*</button>*/}
    </div>

  </div>);
}

export default TableButtons;
